module.exports = __webpack_public_path__ + "img/neogeo_logo-blanc.611348ca.png";